import { Box, Checkbox, FormHelperText, Stack } from '@mui/material';
import { forwardRef, useEffect } from 'react';
import { useEntityPermission } from '@ui-framework/index';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import {
  useAvailabilitySlotTypes,
  TimeSlotTypeChip,
} from '@product-framework/index';

const TimeSlotsSelector = forwardRef((props, ref) => {
  const { control, setValue, clearErrors } = useFormContext();
  const { slotTypes, getSlotByCode } = useAvailabilitySlotTypes();
  const { isReadOnly } = useEntityPermission();
  const { container = null } = props;

  const slotContainer = useWatch({
    control,
    name: container?.name || 'UNKNOWN',
  });

  const timeSlots = useWatch({
    control,
    name: props.name || 'UNKNOWN',
  });

  const disabled = props?.disabled;

  useEffect(() => {
    if (container && container?.clearOnValue === slotContainer) {
      setValue(props?.name, []);
    }
  }, [slotContainer]);

  useEffect(() => {
    if (container?.name && Array.isArray(timeSlots) && timeSlots.length > 0) {
      clearErrors(props?.name);
    }
  }, [timeSlots]);

  if (isReadOnly(props?.permission, timeSlots)) {
    return (
      <Box sx={{ mt: 1 }}>
        {timeSlots.map(item => {
          const s = getSlotByCode({ code: item.code });
          return (
            <Box key={item.code} sx={{ mb: 1 }}>
              <TimeSlotTypeChip name={s.name} code={item.code} />{' '}
            </Box>
          );
        })}
      </Box>
    );
  }

  return (
    <Box ref={ref} {...(props?.sx && { sx: props.sx })}>
      <Controller
        control={control}
        name={props.name}
        render={({ field, fieldState: { error: fsError } }) => {
          const currentValue = field.value || [];
          const selectedCodes = currentValue.map(x => x.code);

          return (
            <Box>
              {slotTypes.map(item => {
                return (
                  <Stack
                    key={item.code}
                    direction="row"
                    alignItems="center"
                    spacing={0.1}
                    component="label"
                    sx={{
                      cursor: 'pointer',
                      userSelect: 'none',
                    }}>
                    <Checkbox
                      disabled={disabled}
                      size="small"
                      checked={selectedCodes.includes(item.code)}
                      onChange={e => {
                        if (e.target.checked) {
                          field.onChange([
                            ...currentValue,
                            { code: item.code },
                          ]);
                        } else {
                          field.onChange(
                            currentValue.filter(x => x.code !== item.code),
                          );
                        }
                      }}
                    />
                    <TimeSlotTypeChip
                      disabled={disabled || !selectedCodes.includes(item.code)}
                      name={item.name}
                      code={item.code}
                    />
                  </Stack>
                );
              })}
              {fsError?.message && (
                <Box>
                  <FormHelperText error>{fsError.message}</FormHelperText>
                </Box>
              )}
            </Box>
          );
        }}
      />
    </Box>
  );
});

export default TimeSlotsSelector;
